import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import {RouterLink} from 'src/routes/components';

import {BreadcrumbsLinkProps} from './types';
import {useTheme} from '@mui/material';

// ----------------------------------------------------------------------

type Props = {
  link: BreadcrumbsLinkProps;
  activeLast?: boolean | string;
  disabled: boolean | string;
  className?: string;
  sx?: any;
};

export default function BreadcrumbsLink({
  link,
  activeLast,
  disabled,
  sx
}: Props) {
  const theme = useTheme();
  const styles = {
    typography: 'body1',
    alignItems: 'center',
    color: theme.palette.primary.lighter,
    fontWeight: '600 !important',
    display: 'inline-flex',
    ...(disabled &&
      !activeLast && {
        cursor: 'default',
        pointerEvents: 'none',
        color: 'text.disabled'
      })
  };

  const handleClick = () => {
    if (link.onClick) {
      link.onClick();
    }
  };

  const renderContent = (
    <>
      {link.icon && (
        <Box
          component="span"
          sx={{
            mr: 1,
            display: 'inherit',
            '& svg': {width: 20, height: 20}
          }}>
          {link.icon}
        </Box>
      )}

      {link.name}
    </>
  );

  if (link.href) {
    return (
      <Link component={RouterLink} href={link.href} sx={{...styles, ...sx}}>
        {renderContent}
      </Link>
    );
  } else if (link.clickable) {
    return (
      <Link onClick={handleClick} sx={{...styles, ...sx}}>
        {renderContent}
      </Link>
    );
  }

  return <Box sx={styles}> {renderContent} </Box>;
}
